import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import VueLocalStorage from 'vue-ls'

Vue.use(VueLocalStorage, { namespace: 'publishRu__' })
Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#print-house')
